import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m21.7 7.626-5-4.888a.98.98 0 0 0-1.4 0l-13 12.708c-.2.196-.3.391-.3.685v4.887c0 .587.4.978 1 .978h5c.3 0 .5-.098.7-.293l13-12.709a.93.93 0 0 0 0-1.368M7.6 20.04H4v-3.52L16 4.79l3.6 3.519z"
    }, null, -1)
  ]))]))
}
export default { render: render }